'use client';

import { useEffect } from 'react';
import { HelpCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useHelpStore } from '@/lib/help/store';

export function HelpButton() {
  const toggle = useHelpStore((s) => s.toggle);
  const isOpen = useHelpStore((s) => s.isOpen);

  // Keyboard shortcut: Ctrl/Cmd + ?
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === '/') {
        e.preventDefault();
        toggle();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [toggle]);

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant={isOpen ? 'secondary' : 'ghost'}
            size="icon"
            onClick={toggle}
            aria-label="Toggle help panel"
          >
            <HelpCircle className="h-5 w-5" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom">
          <p>Help & Documentation</p>
          <p className="text-xs text-muted-foreground">Ctrl+Shift+?</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
